'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mn_MN = require('../vc-pagination/locale/mn_MN');

var _mn_MN2 = _interopRequireDefault(_mn_MN);

var _mn_MN3 = require('../date-picker/locale/mn_MN');

var _mn_MN4 = _interopRequireDefault(_mn_MN3);

var _mn_MN5 = require('../time-picker/locale/mn_MN');

var _mn_MN6 = _interopRequireDefault(_mn_MN5);

var _mn_MN7 = require('../calendar/locale/mn_MN');

var _mn_MN8 = _interopRequireDefault(_mn_MN7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  locale: 'mn-mn',
  Pagination: _mn_MN2['default'],
  DatePicker: _mn_MN4['default'],
  TimePicker: _mn_MN6['default'],
  Calendar: _mn_MN8['default'],
  Table: {
    filterTitle: 'Хайх цэс',
    filterConfirm: 'OK',
    filterReset: 'Цэвэрлэх',
    selectAll: 'Бүгдийг сонгох',
    selectInvert: 'Бусдыг сонгох'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Цуцлах',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Цуцлах'
  },
  Transfer: {
    searchPlaceholder: 'Хайх',
    itemUnit: 'Зүйл',
    itemsUnit: 'Зүйлүүд'
  },
  Upload: {
    uploading: 'Хуулж байна...',
    removeFile: 'Файл устгах',
    uploadError: 'Хуулахад алдаа гарлаа',
    previewFile: 'Файлыг түргэн үзэх',
    downloadFile: 'Файлыг татах'
  },
  Empty: {
    description: 'Мэдээлэл байхгүй байна'
  }
};